"use strict";
module.exports = {
    entityModel: 'customerSubUnit',
    events: {
        CUSTOMER_SUB_UNIT_UPDATED: 'CUSTOMER_SUB_UNIT_UPDATED',
        CUSTOMER_SUB_UNIT_DELIVERY_DETAILS_CHANGED: 'CUSTOMER_SUB_UNIT_DELIVERY_DETAILS_CHANGED',
        CUSTOMER_SUB_UNIT_INVOICE_DETAILS_CHANGED: 'CUSTOMER_SUB_UNIT_INVOICE_DETAILS_CHANGED',
        CUSTOMER_SUB_UNIT_CONTACTS_UPDATED: 'CUSTOMER_SUB_UNIT_CONTACTS_UPDATED',
        CUSTOMER_SUB_UNIT_CREATED: 'CUSTOMER_SUB_UNIT_CREATED',
        CUSTOMER_SUB_UNIT_APPROVED: 'CUSTOMER_SUB_UNIT_APPROVED',
        CUSTOMER_SUB_UNIT_BLOCKED: 'CUSTOMER_SUB_UNIT_BLOCKED',
        CUSTOMER_SUB_UNIT_MERGED: 'CUSTOMER_SUB_UNIT_MERGED',
        CUSTOMER_SUB_UNIT_MARKED_AS_DUPLICATE: 'CUSTOMER_SUB_UNIT_MARKED_AS_DUPLICATE',
        CUSTOMER_SUB_UNIT_UNBLOCKED: 'CUSTOMER_SUB_UNIT_UNBLOCKED',
        CUSTOMER_SUB_UNIT_INVOICE_INFO_CHANGE_REQUESTED: 'CUSTOMER_SUB_UNIT_INVOICE_INFO_CHANGE_REQUESTED',
        CUSTOMER_SUB_UNIT_SET_EXTERNAL_CUSTOMER_NUMBER: 'CUSTOMER_SUB_UNIT_SET_EXTERNAL_CUSTOMER_NUMBER',
        CUSTOMER_SUB_UNIT_CONNECTED_TO_QVANTI: 'CUSTOMER_SUB_UNIT_CONNECTED_TO_QVANTI',
        CUSTOMER_SUB_UNIT_DISCONNECTED_FROM_QVANTI: 'CUSTOMER_SUB_UNIT_DISCONNECTED_FROM_QVANTI',
        CUSTOMER_SUB_UNIT_ALCOHOL_LICENSE_APPROVED: 'CUSTOMER_SUB_UNIT_ALCOHOL_LICENSE_APPROVED',
        CUSTOMER_SUB_UNIT_ALCOHOL_LICENSE_REVOKED: 'CUSTOMER_SUB_UNIT_ALCOHOL_LICENSE_REVOKED',
    },
    actions: {
        get: 'v1.customerSubUnit.get',
        list: 'v1.customerSubUnit.list',
        setDeliveryRules: 'v1.customerSubUnit.setDeliveryRules',
        writeCustomerSubUnit: 'v1.customerSubUnit.writeCustomerSubUnit',
        changeDeliveryDetails: 'v1.customerSubUnit.changeDeliveryDetails',
        changeInvoiceDetails: 'v1.customerSubUnit.changeInvoiceDetails',
        approveCustomerSubUnit: 'v1.customerSubUnit.approveCustomerSubUnit',
        blockCustomerSubUnit: 'v1.customerSubUnit.blockCustomerSubUnit',
        unblockCustomerSubUnit: 'v1.customerSubUnit.unblockCustomerSubUnit',
        approveAlcoholLicense: 'v1.customerSubUnit.approveAlcoholLicense',
        revokeAlcoholLicense: 'v1.customerSubUnit.revokeAlcoholLicense',
        setCustomerType: 'v1.customerSubUnit.setCustomerType',
        requestNewInvoiceInformation: 'v1.customerSubUnit.requestNewInvoiceInformation',
        writeContact: 'v1.customerSubUnit.writeContact',
        writeContactAndInvite: 'v1.customerSubUnit.writeContactAndInvite',
        removeContact: 'v1.customerSubUnit.removeContact',
        setExternalCustomerNumber: 'v1.customerSubUnit.setExternalCustomerNumber',
        markAsDuplicateOf: 'v1.customerSubUnit.markAsDuplicateOf',
        ensureInvariants: 'v1.customerSubUnit.ensureInvariants',
        connectToQvanti: 'v1.customerSubUnit.connectToQvanti',
        disconnectFromQvanti: 'v1.customerSubUnit.disconnectFromQvanti',
        upsert: 'v1.customerSubUnit.upsert',
        upsertWhenEmpty: 'v1.customerSubUnit.upsertWhenEmpty',
        updateWhenEmpty: 'v1.customerSubUnit.updateWhenEmpty',
        update: 'v1.customerSubUnit.update',
    },
    deliveryCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    customerTypes: {
        horeca: 'horeca',
        dvh: 'dvh',
        wholesale: 'wholesale',
        office: 'office',
        systembolaget: 'systembolaget',
        supplier: 'supplier',
        export: 'export',
        other: 'other',
    },
    termsOfPayments: {
        0: '0',
        10: '10',
        15: '15',
        20: '20',
        30: '30',
        35: '35',
        60: '60',
        70: '70',
        A: 'A',
        K: 'K',
        PF: 'PF',
    },
    invoiceDeliveryTypes: {
        PRINT: 'PRINT',
        EMAIL: 'EMAIL',
        ELECTRONICINVOICE: 'ELECTRONICINVOICE',
    },
    invoiceCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    deliveryCounties: {
        'SE-O': 'SE-O',
        'SE-N': 'SE-N',
        'SE-M': 'SE-M',
        'SE-K': 'SE-K',
        'SE-I': 'SE-I',
        'SE-H': 'SE-H',
        'SE-G': 'SE-G',
        'SE-F': 'SE-F',
        'SE-E': 'SE-E',
        'SE-D': 'SE-D',
        'SE-C': 'SE-C',
        'SE-Z': 'SE-Z',
        'SE-Y': 'SE-Y',
        'SE-X': 'SE-X',
        'SE-W': 'SE-W',
        'SE-BD': 'SE-BD',
        'SE-T': 'SE-T',
        'SE-S': 'SE-S',
        'SE-U': 'SE-U',
        'SE-AC': 'SE-AC',
        'SE-AB': 'SE-AB',
    },
    customerSubUnitContacts: {},
};
